import specs3 from "../../assets/img/specs3.png";

export default function ArSection() {
  return (
    <section className="key-features section grid" id="key-features">
      <h2 className="section__title section__title-gradient">3D & AR View</h2>

      <div className="specs__container container grid">
        <div className="specs__content">
          <div className="specs__data">
            <i className="ri-focus-3-line specs__icon"></i>
            <h3 className="specs__title">
              <strong>3D View</strong>
            </h3>
            <span className="specs__subtitle">
              Examine aircraft from every angle in immersive 3D.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-vr-line specs__icon"></i>
            <h3 className="specs__title">
              <strong>Augmented Reality</strong>
            </h3>
            <span className="specs__subtitle">
              Place life-sized jets in your own space using AR.
            </span>
          </div>
        </div>

        <div >
          <img src={specs3} alt="App Features" className="img-ArSection" />
        </div>
      </div>
    </section>
  );
}
